import React from 'react';

import { List } from '../List';
import { SubContentComponent } from '../SubContentComponent';

import styles from './styles.module.scss';

export const BulletList: React.FC<components.BulletList> = ({ title, list, listTestId }) => (
  <SubContentComponent title={title} className={styles.listTitle}>
    <List list={list} render={(listItem) => <span>{listItem}</span>} testId={listTestId} />
  </SubContentComponent>
);
